import { updateCallIsQuestionAnswerHelpfulDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateCallIsQuestionAnswerHelpfulCallable = getCallable(
  updateCallIsQuestionAnswerHelpfulDefinition,
);
